export const videos = [
  {
    type: "pdf",
    title: "Manual de Usuario",
    visible: true,
    nombre: "documentacion/Manual-Sistema-Ticket.pdf",
  },
  {
    type: "pdf",
    title: "Protocolo Control de Cambios",
    visible: true,
    nuevo: true,
    nombre: "documentacion/Protocolo-Control-de-Cambios.pdf",
  },
  {
    type: "video",
    title: "Soporte/Mantención",
    visible: true,
    nombre: "1SMPJZMsR-LIRPVL9Yt4EEsnfSY49Omt6/preview?",
  },
  {
    type: "video",
    title: "Nuevos Desarrollos",
    visible: true,
    nombre: "1bbZwABsfJyNN4IyW44Sew2aFeB6NTaIL/preview?",
  },
  {
    type: "video",
    title: "Actualización",
    visible: true,
    nombre: "1wAE9Ofeu__vx7Eud1txJXBZGeMpa5seN/preview?",
  },
  {
    type: "video",
    title: "Cotización/Mejoras",
    visible: true,
    nombre: "1m9WyWED0gbKI9kLKY1PSHdKoQ6T8NAEz/preview?",
  },
  {
    type: "video",
    title: "Capacitaciones/Reuniones",
    visible: true,
    nombre: "1-mZxUdq5XVqfGHRRzJkKf0wkLvNWd5Yj/preview?",
  },
  {
    type: "video",
    title: "Cambiar Clave",
    visible: true,
    nombre: "1LQFg5JUp-h0KqBTv_mAnsVx5VI5fA2c8/preview?",
  },
  {
    type: "video",
    title: "Actualizar Imagen",
    visible: true,
    nombre: "16aQQHosjSftSS5aJx4H1Rf8XUvF43w7L/preview?",
  },
];
